export default "__VITE_ASSET__DC3n6ITh__"